import { render } from "./MovementWander.vue?vue&type=template&id=4d8dfa9c"
import script from "./MovementWander.vue?vue&type=script&lang=js"
export * from "./MovementWander.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__